//import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// import { NavigationBar } from "../components/MasterLayout/NavigationBar";
// import { Profile } from "../components/Profile/Profile";

export const PageNotFound = () => {
  return (
    <>
      <Container>
        <Row>
          <Col>
            <div className="page-404 text-center align-middle">
              <h1>404</h1>
              <h5 className="text-uppercase">Page not found</h5>
              <p>Sorry, but the requested page is not found.</p>
              <br />
              <div
                className='btn' 
                style={{background: '#ea5455', color: 'white'}} 
                onClick={() => window.location.href = '/'}
              >
                Home
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
